import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const UiTableHead = (props) => {
  const { columns, columnButtons, displayCheckbox } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding={displayCheckbox ? 'checkbox' : 'none'}
          style={{ width: displayCheckbox ? '48px' : '24px' }}
          className='checkbox-column'
        ></TableCell>
        {columns.map((headCell, index) => (
          <TableCell
            key={headCell.key || index}
            align={index === 0 ? 'right' : 'center'}
            padding='default'
            sortDirection={false}
            style={{ width: headCell?.width }}
            className={headCell?.className}
          >
            {headCell.label}
          </TableCell>
        ))}
        {columnButtons?.length > 0 ? (
          <TableCell align='left' padding='default' sortDirection={false}>
            <div className='ui-table-column-buttons'>
              {columnButtons.map((headBtn, index) => (
                <div
                  key={`columnButton-${headBtn.key}` || index}
                  className={`${columnButtons?.length > 1 ? 'pr-12' : ''}`}
                >
                  {headBtn?.render()}
                </div>
              ))}
            </div>
          </TableCell>
        ) : (
          <TableCell
            align={'left'}
            padding={'checkbox'}
            sortDirection={false}
          ></TableCell>
        )}
      </TableRow>
    </TableHead>
  );
};

UiTableHead.propTypes = {
  columns: PropTypes.array.isRequired,
  columnButtons: PropTypes.array,
  displayCheckbox: PropTypes.bool,
};

export default UiTableHead;
